const getters = {
    drawStatus: state => state.drawStatus,
    drawErrors: state => state.drawErrors,
    seasons: state => state.seasons,
    divisions: state => state.divisions,
    teams: state => state.teams,
    draw: state => state.draw,
    result: state => state.result,
}

export default getters
